var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3334 8.33397H1.66669C0.746688 8.33397 2.1201e-05 7.58897 2.1201e-05 6.66731C2.1201e-05 5.74564 0.746688 5.00064 1.66669 5.00064H23.47L20.8734 2.98397C20.1467 2.41897 20.015 1.37064 20.58 0.64564C21.145 -0.0826931 22.1934 -0.21436 22.9184 0.35064L29.355 5.35064C29.7667 5.66897 30.0034 6.16064 30 6.68231C29.9967 7.20064 29.75 7.68897 29.3334 8.00064L22.6667 13.0006C22.3667 13.2256 22.015 13.334 21.6684 13.334C21.1617 13.334 20.66 13.104 20.3334 12.6673C19.7817 11.9306 19.93 10.8856 20.6667 10.334L23.3334 8.33397ZM6.6667 20.0006H28.3334C29.2534 20.0006 30 20.7456 30 21.6673C30 22.589 29.2534 23.334 28.3334 23.334H6.53003L9.1267 25.3506C9.85337 25.9156 9.98503 26.964 9.42003 27.689C9.0917 28.1123 8.60003 28.334 8.10337 28.334C7.74503 28.334 7.38503 28.2206 7.0817 27.984L0.645035 22.984C0.233368 22.6656 -0.00329859 22.174 3.4744e-05 21.6523C0.00336808 21.134 0.250035 20.6456 0.666701 20.334L7.33337 15.334C8.0717 14.7823 9.11503 14.9306 9.6667 15.6673C10.2184 16.404 10.07 17.449 9.33337 18.0006L6.6667 20.0006Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferArrows);
export default __webpack_public_path__ + "static/media/transfer-arrows.c0285c2b0d20d45a95e90fd2d446260c.svg";
export { ForwardRef as ReactComponent };